(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const ATTR_INITIAL_POSITION = 'initial-image-position';

    customElements.define('product-gallery', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]',
            next: '[data-next]',
            prev: '[data-prev]'
        }

        subscriptions = {
            'variant:update': '_onVariantChange'
        }

        render() {
            this._initSwiper();
            this.subscribe('variant:update');
        }

        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, {
                autoHeight: true,
                pagination: {
                    el: this.$pagination,
                    type: 'bullets'
                },
                navigation: {
                    nextEl: this.$next,
                    prevEl: this.$prev,
                },
                breakpoints: {
                    992: {
                        allowTouchMove: false
                    }
                }
            });
            if (this.initialPosition) {
                this.swiper.slideTo(+this.initialPosition - 1)
            }else{
              if(document.querySelector(".product-page-section")){
                var ID = this.id;
                var mainSlider = document.querySelector(".product-page-section").querySelector("#"+ID);
                if(mainSlider){
                  var activeSlide = mainSlider.querySelector(".swiper-slide-active");
                  if(activeSlide){
                    var activeIndex = [...activeSlide.parentNode.children].indexOf(activeSlide);
                    if(activeIndex){
                      
                       this.swiper.slideTo(activeIndex)
                    }
                  }
                }
              }
            }
        }

        _onVariantChange(data) {
            if(data?.imagePosition) {
                this.swiper.slideTo(data.imagePosition - 1);
            }
        }

        get slider() {
            return this.swiper;
        }

        get initialPosition() {
            return this.getAttribute(ATTR_INITIAL_POSITION)
        }
    })
})();